import { useNavigate } from 'react-router';
import { Play } from 'lucide-react';

export function WorkflowLaunchPanel(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
        ODD Actions
      </div>
      <button
        type="button"
        onClick={() => navigate('/workflows')}
        className="flex w-full items-center gap-2 rounded-md border border-border bg-surface px-3 py-2 text-left text-xs text-text-secondary transition-colors hover:bg-surface-elevated"
      >
        <Play className="h-3.5 w-3.5 text-primary" />
        <span>Launch workflow</span>
      </button>
      <div className="text-[10px] leading-4 text-text-tertiary">
        Open the workflow runner for implementation, verification, or recovery actions.
      </div>
    </div>
  );
}
